import { Box, Chip } from '@mui/material';
import { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [-30, -20],
            },
          },
        ],
      },
    }}
  />
))(({ theme }) => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#949494',
      color: '#fff',
      fontSize: 14,
      borderRadius: '99px',
      padding: '5px 10px',
    },
  };
});

const FirstArrivingUnit = ({ firstUnit, units }) => {
  const { visibleUnits, hiddenUnits } = useMemo(() => {
    const allUnits = units?.split(', ') || [];
    const filteredUnits = allUnits.filter((u) => u && u !== firstUnit);

    const visibleUnits = [firstUnit, ...filteredUnits.slice(0, 2)].filter(
      Boolean
    );
    const hiddenUnits = filteredUnits.slice(2);

    return { visibleUnits, hiddenUnits };
  }, [firstUnit, units]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {visibleUnits.join(', ') || '-'}

        {hiddenUnits.length > 0 ? (
          <CustomTooltip title={hiddenUnits.join(', ')} placement="right-start">
            <Chip
              label={'+' + hiddenUnits.length}
              variant="outlined"
              size="small"
              className="ms-1"
              sx={{
                '&.MuiChip-root:hover': {
                  background: '#949494',
                  color: '#fff',
                },
                '& .MuiChip-label ': {
                  marginTop: '1px',
                  cursor: 'pointer',
                  fontSize: '14px',
                },
              }}
            />
          </CustomTooltip>
        ) : null}
      </Box>
    </>
  );
};

export default FirstArrivingUnit;
